import angular from 'angular';
import { has } from 'lodash';

const FLOAT = 'float';
const INTEGER = 'integer';

module.exports = angular.module('common.directives.percent', [
  require('../filters/percentage')
])
.directive('type', function(percentageFilter) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      if (attrs.type !== 'percent' || !ngModel) return;

      let type = has(attrs, 'integerPercent') ? INTEGER : FLOAT;

      // String Percent -> Decimal Percent
      ngModel.$parsers.push(function(value) {
        if (!value) return null;

        if (type == FLOAT) {
          let percent = parseFloat(value);
          if (isNaN(percent)) {
            return 0;
          } else {
            return percent / 100;
          }
        } else {
          let percent = parseInt(value, 10);
          if (isNaN(percent)) {
            return 0;
          } else {
            return percent;
          }
        }
      });

      // Decimal Percent -> String Percent
      ngModel.$formatters.push(function(value) {
        if (!value && value !== 0) return null;
        if (type == INTEGER) value = value / 100;
        return percentageFilter(value, 2);
      });
    },
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/percent.js
 **/